
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Shivajinagartomumbaicab() {



    const cardData =
    {
        keyword: '  Shivajinagar to Mumbai Cab',
        heading: 'Mauli Cabs:   Shivajinagar to Mumbai Cab',
        headingDescription: 'Mauli Cabs offers reliable and comfortable Shivajinagar to Mumbai cab services, ensuring a smooth and stress-free ride to the city. Whether you are traveling for business, leisure, or an event, we provide a range of well-maintained vehicles including sedans, SUVs, and premium cabs to suit your needs. With professional drivers, transparent pricing, no hidden charges, and a strong focus on punctuality and customer satisfaction, Mauli Cabs guarantees a comfortable and hassle-free journey from Shivajinagar to Mumbai.',

        top: 'Top Places to Visit in Mumbai with Mauli Cabs',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "The Gateway of India is an iconic monument located on the waterfront in South Mumbai. Built during the 20th century, it served as a ceremonial entrance to India for Viceroys and new Governors of Bombay."
    },
    {
        "title": "Marine Drive",
        "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6-kilometer-long boulevard along the South Mumbai coast. It's a perfect place for a scenic walk and offers stunning sunset views."
    },
    {
        "title": "Elephanta Caves",
        "description": "Elephanta Caves are a network of sculpted caves located on Elephanta Island, about 11 km from the city. They feature impressive rock-cut sculptures and are a UNESCO World Heritage Site."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus",
        "description": "This UNESCO World Heritage Site is an outstanding example of Victorian Gothic Revival architecture in India, and it serves as one of Mumbai's busiest railway stations."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "The Siddhivinayak Temple is a revered Hindu temple dedicated to Lord Ganesha. Located in Prabhadevi, it attracts thousands of devotees daily seeking blessings."
    },
    {
        "title": "Colaba Causeway",
        "description": "Colaba Causeway is a vibrant shopping street lined with street stalls and boutiques selling clothes, jewelry, handicrafts, and antiques, making it a must-visit for shopaholics."
    },
    {
        "title": "Juhu Beach",
        "description": "Juhu Beach is one of Mumbai’s most famous beaches, popular for its street food, especially bhelpuri and pav bhaji, and for evening strolls along the Arabian Sea."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "Located on an islet off the coast of Worli, the Haji Ali Dargah is a mosque and tomb built in memory of a wealthy Muslim merchant who gave up his worldly possessions before making a pilgrimage to Mecca."
    },
    {
        "title": "Chowpatty Beach",
        "description": "Chowpatty Beach is famous for its lively atmosphere, street food, and being a central spot for Ganesh Chaturthi celebrations where devotees immerse Ganesh idols in the sea."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "Located in the northern part of Mumbai, Sanjay Gandhi National Park is a green oasis offering trekking, a mini train ride, and a chance to visit the historic Kanheri Caves."
    }
],

"services": [
    {
      "name": "Shivajinagar to Mumbai Innova Crysta",
      "description": "Book a luxurious Toyota Innova Crysta for your trip from Shivajinagar to Mumbai. Ideal for larger groups or families, with ample space and comfort for a smooth journey."
    },
    {
      "name": "Pune Station to Mumbai Cab Service",
      "description": "Get a convenient and reliable cab service from Pune Station to Mumbai. Enjoy a comfortable ride with professional drivers and timely service."
    },
    {
      "name": "Pune to Mumbai Cab Round Trip",
      "description": "Book a round-trip cab from Pune to Mumbai for a hassle-free journey. Enjoy the convenience of a dedicated driver for your entire trip, ensuring a comfortable experience."
    },
    {
      "name": "Bundgarden to Mumbai Cab",
      "description": "Travel from Bundgarden to Mumbai with ease. Choose from a range of vehicles, and enjoy a smooth, timely ride with experienced drivers."
    },
    {
      "name": "Yerwada to Mumbai Cab Service",
      "description": "Get a reliable cab service from Yerwada to Mumbai. Enjoy a comfortable ride with professional drivers and well-maintained vehicles."
    },
    {
      "name": "Camp to Mumbai Cab Service",
      "description": "Book a convenient and affordable cab from Camp to Mumbai. Enjoy a smooth ride with professional drivers and a range of vehicle options."
    },
    {
      "name": "Wakdewadi to Mumbai Cab",
      "description": "Book a cab from Wakdewadi to Mumbai for a comfortable and smooth journey. Enjoy professional drivers and well-maintained vehicles."
    },
    {
      "name": "Khadki to Mumbai Cab Service",
      "description": "Travel from Khadki to Mumbai with ease. Choose from a range of comfortable vehicles and enjoy timely service."
    },
    {
      "name": "Swargate to Mumbai Cabs",
      "description": "Book a reliable cab from Swargate to Mumbai for a comfortable, hassle-free ride. Enjoy timely pickups and professional drivers."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "Choose a Maruti Ertiga for your journey from Pune to Mumbai. Ideal for families or small groups, with ample space for passengers and luggage."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Book a Toyota Innova for your trip from Pune to Mumbai. Perfect for larger groups, with seating for up to 6 passengers and plenty of space for luggage."
    },
    {
      "name": "Cab Service in Shivaji Nagar Pune",
      "description": "Get professional cab services in Shivaji Nagar, Pune. Whether it's for a local trip, airport transfer, or long-distance journey, enjoy a smooth and comfortable ride."
    },
    {
      "name": "Shivajinagar to Dadar Cab Service",
      "description": "Book a reliable cab from Shivajinagar to Dadar. Enjoy a comfortable ride with experienced drivers and a variety of vehicle options."
    },
    {
      "name": "Shivaji Nagar to Andheri Cab Service",
      "description": "Travel from Shivaji Nagar to Andheri with a comfortable and reliable cab service. Choose from various vehicles and enjoy a smooth, punctual journey."
    },
    {
      "name": "Pune Station to Mumbai Cab",
      "description": "Book a dependable and comfortable cab from Pune Station to Mumbai. Choose from a variety of vehicles for a smooth, hassle-free journey."
    },
    {
      "name": "Best Cab Service Pune to Mumbai",
      "description": "Get the best cab service from Pune to Mumbai. Enjoy comfortable vehicles, professional drivers, and timely service at competitive rates."
    },
    {
      "name": "Innova Crysta on Rent in Shivaji Nagar Pune",
      "description": "Rent a Toyota Innova Crysta in Shivaji Nagar, Pune for a luxurious travel experience. Ideal for family trips, group travel, and business outings."
    },
    {
      "name": "Ertiga on Rent in Shivaji Nagar",
      "description": "Rent a Maruti Ertiga for your travel needs in Shivaji Nagar. Ideal for families or small groups with ample space for luggage and comfortable seating."
    },
    {
      "name": "Mauli Cabs Pune",
      "description": "Choose Mauli Cabs for your travel needs in Pune. Offering reliable and comfortable taxi services for all types of trips, including local and outstation rides."
    },
    {
      "name": "Cab Service in Pune",
      "description": "Book reliable cab services in Pune for your local and outstation trips. Choose from various vehicles and enjoy comfortable, professional rides."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Book a reliable and comfortable cab for your trip from Pune to Mumbai Airport. Choose from a range of vehicles and enjoy timely, smooth rides."
    },
    {
      "name": "Pune Mumbai Cab",
      "description": "Get a reliable and comfortable cab service from Pune to Mumbai. Whether for business or leisure, enjoy a smooth and stress-free ride."
    }
  ],
  "tableData": [
    ["Shivajinagar to Mumbai Innova Crysta", "Pune Station to Mumbai Cab Service"],
    ["Pune to Mumbai Cab Round Trip", "Bundgarden to Mumbai Cab"],
    ["Yerwada to Mumbai Cab Service", "Camp to Mumbai Cab Service"],
    ["Wakdewadi to Mumbai Cab", "Khadki to Mumbai Cab Service"],
    ["Swargate to Mumbai Cabs", "Pune to Mumbai Ertiga Cab"],
    ["Pune to Mumbai Innova Cab", "Cab Service in Shivaji Nagar Pune"],
    ["Shivajinagar to Dadar Cab Service", "Shivaji Nagar to Andheri Cab Service"],
    ["Pune Station to Mumbai Cab", "Best Cab Service Pune to Mumbai"],
    ["Innova Crysta on Rent in Shivaji Nagar Pune", "Ertiga on Rent in Shivaji Nagar"],
    ["Mauli Cabs Pune", "Cab Service in Pune"],
    ["Pune to Mumbai Airport Cab", "Pune Mumbai Cab"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Pickup from Shivajinagar",
        "WhyChoosedescription": "Mauli Cabs offers dependable and punctual cab service from Shivajinagar to Mumbai, making sure you reach your destination on time with a stress-free experience."
    },
    {
        "WhyChooseheading": "Comfortable and Clean Cabs",
        "WhyChoosedescription": "Travel in air-conditioned, sanitized vehicles with comfortable seating and ample luggage space. Choose from a range of sedans, SUVs, and premium cars for your Shivajinagar to Mumbai ride."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with the Route",
        "WhyChoosedescription": "Our professional drivers know the fastest and safest routes between Shivajinagar and Mumbai. They ensure a smooth and efficient journey with minimal traffic delays."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Fares",
        "WhyChoosedescription": "Enjoy competitive pricing with no hidden charges. Mauli Cabs provides upfront fare details for your Shivajinagar to Mumbai cab so you can book with confidence."
    },
    {
        "WhyChooseheading": "24/7 Availability for Any Schedule",
        "WhyChoosedescription": "Whether it’s a late-night trip or an early-morning departure, our cab services are available 24/7 to accommodate your travel plans from Shivajinagar to Mumbai."
    },
    {
        "WhyChooseheading": "Easy Booking and Live Tracking",
        "WhyChoosedescription": "Book your cab in just a few clicks via our app or website and track your ride in real-time. Get driver details, ETA, and live location updates instantly."
    },
    {
        "WhyChooseheading": "Safe and Secure Travel",
        "WhyChoosedescription": "Your safety is our priority. Our cabs are GPS-enabled, sanitized after every trip, and driven by background-verified drivers following all safety protocols."
    },
    {
        "WhyChooseheading": "Flexible Payment Options",
        "WhyChoosedescription": "Choose from various payment modes like cash, UPI, credit/debit cards, and mobile wallets for a convenient and hassle-free payment experience."
    }
]

















    }


    const faqData = [
        {
            question: 'How do I book a cab from Shivajinagar to Mumbai with Mauli Cabs?',
            answer: 'Booking a cab from Shivajinagar to Mumbai with Mauli Cabs is easy. Simply visit our website or mobile app, enter "Shivajinagar" as your pickup location and "Mumbai" as your destination. Choose the vehicle type you prefer and confirm your booking. If you need assistance, our customer support team is happy to help.',
        },
        {
            question: 'What types of cabs are available for the Shivajinagar to Mumbai route?',
            answer: 'Mauli Cabs offers a variety of vehicles for your journey from Shivajinagar to Mumbai, including Hatchbacks, Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Select the vehicle that fits your needs for comfort, luggage, and group size.',
        },
        {
            question: 'Is the fare from Shivajinagar to Mumbai fixed?',
            answer: 'Yes, the fare for the Shivajinagar to Mumbai route is fixed. The price includes tolls, fuel, taxes, and driver charges, with no hidden fees. You will see the full fare before confirming your booking.',
        },
        {
            question: 'How long does the journey from Shivajinagar to Mumbai take?',
            answer: 'The journey from Shivajinagar to Mumbai typically takes around 3.5 to 5 hours, depending on traffic and road conditions. To avoid delays, it’s recommended to leave early or avoid peak travel times.',
        },
        {
            question: 'Can I book a one-way or round-trip cab from Shivajinagar to Mumbai?',
            answer: 'Yes, you can book either a one-way or round-trip cab from Shivajinagar to Mumbai. If you plan to return the same or next day, a round-trip is usually more cost-effective.',
        },
        {
            question: 'Can I schedule an early morning or late-night cab from Shivajinagar?',
            answer: 'Absolutely! Mauli Cabs operates 24/7, and you can schedule a pickup at any time, whether it’s early morning or late at night. We’ll make sure you reach your destination on time.',
        },
        {
            question: 'Can I carry extra luggage on the Shivajinagar to Mumbai journey?',
            answer: 'Yes, you can carry extra luggage. For larger or bulkier items, we recommend booking a bigger vehicle like an SUV or Innova Crysta to ensure a comfortable and spacious ride.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Akash Jadhav",
            position: "Software Engineer",
            text: "I often travel from Shivajinagar to Mumbai for work, and Mauli Cabs has never let me down. The drivers are professional, the cars are clean, and the rides are always smooth. I highly recommend their service!",
            image: "/img/testimonial/testimonial-thumb-1-39.png",
        },
        {
            name: "Miss. Neha Pandit",
            position: "Travel Blogger",
            text: "Booked a cab from Shivajinagar to Mumbai for a weekend trip. The booking was simple, the vehicle was clean and comfortable, and the driver was polite. I’ll definitely be using Mauli Cabs again for my future trips!",
            image: "/img/testimonial/testimonial-thumb-1-40.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Shivajinagar to Mumbai Cab Service",
        "description": "Mauli Cabs offers convenient and affordable cab services from Shivajinagar to Mumbai. Choose from a range of well-maintained vehicles including Innova Crysta, Ertiga, and other luxury sedans for a smooth ride to destinations like Mumbai Airport, Dadar, Andheri, and more.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "520"
        }
      };
      
      


    return (
        <div>
            <GTag/>

<Helmet>
        <title>Shivajinagar to Mumbai Cab Service | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book a reliable taxi ride from Shivajinagar to Mumbai with Mauli Cabs. We offer a variety of vehicles including Innova Crysta, Ertiga, and luxury sedans, ensuring a comfortable ride to Mumbai Airport, Dadar, Andheri, and more."
        />
        <meta
          name="keywords"
          content="Shivajinagar to Mumbai innova crysta, Shivajinagar to Mumbai taxi, Shivajinagar to Mumbai airport cab, Shivajinagar to Dadar cab, Pune to Mumbai taxi, Mauli Cabs, Shivajinagar cab service"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/82.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Shivajinagartomumbaicab;